namespace Shared.Dto.Form

[<RequireQualifiedAccess>]
module TalgilTriggerForm =
    type ProgramDto = {
        Id: int
        Name: string
    }

    type ControllerInfoDto = {
        Id: int
        Name: string

        Programs: ProgramDto list
    }

    type NewTriggerDto = {
        ControllerId: int
        ControllerName: string
        Program: ProgramDto
        SensorId: int
        IsActive: bool
    }

    let newTriggerDto
        (controllerId: int)
        (controllerName: string)
        (program: ProgramDto)
        (sensorId: int)
        (isActive: bool)
        : NewTriggerDto =
        {
            ControllerId = controllerId
            ControllerName = controllerName
            Program = program
            SensorId = sensorId
            IsActive = isActive
        }